import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AdminAccessGroupEditPage } from "@/components/pages/users/AdminAccessGroupEditPage";
import { TenantAccessGroupEditPage } from "@/components/pages/users/TenantAccessGroupEditPage";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import {
  hasTenantPermission,
  isSuperAdminRole,
  PlatformRole,
} from "@/utils/accessControl";

export const GroupEditPage = () => {
  const { t } = useTranslation();
  const { id = "" } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const { userProfile, isLoading } = useAuthenticatedUser();
  const backTo = searchParams.get("backTo") || "/users?tab=groups";

  if (!id) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">
          {t("common.notFound", "Not found")}
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  // "View" (read-only) roles can open this screen but must not edit it. Editing
  // requires the administrate permission (full tenant admins and super admins
  // always have it).
  const readOnly =
    !isSuperAdminRole(userProfile) &&
    !hasTenantPermission(userProfile, "users:administrate");

  if (userProfile?.role === PlatformRole.SUPER_ADMIN) {
    return (
      <AdminAccessGroupEditPage id={id} backTo={backTo} readOnly={readOnly} />
    );
  }

  return (
    <TenantAccessGroupEditPage id={id} backTo={backTo} readOnly={readOnly} />
  );
};
